import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { Error404Component } from '../shared/errors/errors.module';

import { AppGuard } from '../../app.guard';
import { FinancesComponent } from './finances.component';
import { EntriesComponent } from './entries/entries.component';
import { CardsComponent } from './cards/cards.component';
import { CategoriesComponent } from './categories/categories.component';
import { EntriesConfig } from './finance.model';


export const routes: Routes = [
  {
    path: 'finances',
    data: { title: 'Finances' },
    children: [
      { path: '', component: FinancesComponent, canActivate: [AppGuard] }, // Default route
      // The Overview is now the dashboard of /finances
      { path: 'overview', redirectTo: '', pathMatch: 'full' },
      { path: 'incomes', component: EntriesComponent, canActivate: [AppGuard],
        data: { title: 'Incomes', collection: 'Incomes', group: 'INCOME', copyPrevious: true } satisfies EntriesConfig },
      { path: 'bills', component: EntriesComponent, canActivate: [AppGuard],
        data: { title: 'Bills', collection: 'Bills', group: 'BILL', copyPrevious: true } satisfies EntriesConfig },
      { path: 'expenses', component: EntriesComponent, canActivate: [AppGuard],
        data: { title: 'Expenses', collection: 'Expenses', group: 'EXPENSE', copyPrevious: false } satisfies EntriesConfig },
      { path: 'credit-card', component: CardsComponent, canActivate: [AppGuard] },
      { path: 'categories', component: CategoriesComponent, canActivate: [AppGuard] },

      { path: '**', component: Error404Component }, // Error 404
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FinancesRoutingModule { }
